window.continueIfAllowed = (controller, actions) ->
  current_controller = $('body').data()?.railsController
  current_action = $('body').data()?.railsAction
  allowed_controllers = if Array.isArray(controller) then controller else [controller]
  allowed_controllers.includes(current_controller) and actions.includes(current_action)
